import React, { useEffect, useState } from "react";
import styled from "styled-components";
import Typography from "../typography";
import { Colors } from "utils/colors";
// import { TextSize, TextWeight } from "../typography/enums";
// import { FiArrowLeft, FiArrowRight } from "react-icons/fi";

interface Iprops {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
}
const Pagination = ({ currentPage, totalPages, onPageChange }: Iprops) => {
  const [page, setPage] = useState(currentPage);
  const [pagesArray, setPagesArray] = useState<number[]>([]);

  const Previous = () => {
    const current = page;
    if (current !== 1) {
      setPage(current - 1);
      onPageChange(current - 1);
    }
  };

  const Next = () => {
    const current = page;
    if (current < totalPages) {
      setPage(current + 1);
      onPageChange(current + 1);
    }
  };

  useEffect(() => {
    const PagesToReturn = () => {
      const array = [];
      const min = 1;
      const max = totalPages;
      let count = 3;
      if (totalPages < 5) {
        for (let i = 1; i < totalPages + 1; i++) {
          array.push(i);
        }
        return setPagesArray(array);
      }

      array.push(min, max, currentPage);

      for (let i = 1; i < count; i++) {
        // add -2 -1 current page
        if (currentPage - i >= min) {
          array.push(currentPage - i);
        }
        // add +2 +1 current page
        if (currentPage + i <= max) {
          array.push(currentPage + i);
        }
        // add -2 -1 max page
        array.push(max - i);
      }

      //remove reoccur
      const mySet = new Set(array);
      const newArray = Array.from(mySet);

      const sorted = newArray.sort((a, b) => {
        return a - b;
      });
      let finalArray = [];
      for (let i = 0; i < sorted.length; i++) {
        finalArray.push(sorted[i]);
        if (sorted[i] + 1 !== sorted[i + 1] && sorted[i + 1]) {
          finalArray.push(-1);
        }
      }
      setPagesArray(finalArray);
    };
    PagesToReturn();
  }, [page, currentPage, totalPages]);
  return (
    <Container>
      <Body>
        <Button onClick={Previous} disabled={currentPage === 1}>
          <IconContainer>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="100%"
              height="100%"
              viewBox="0 0 20 20"
              fill="none"
            >
              <path
                d="M12.5 4.16675L7.5 10.0001L12.5 15.8334"
                stroke="currentColor"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </IconContainer>
          <Typography size={"lg"} weight={"medium"} ml="0.8" m_display="none">
            Previous
          </Typography>
        </Button>
        <Pages>
          {pagesArray.map((page, i) => {
            if (page > 0) {
              return (
                <PageItem
                  key={i}
                  isactive={currentPage === page ? "true" : "false"}
                  onClick={() => {
                    setPage(page);
                    onPageChange(page);
                  }}
                >
                  <Typography lh="2" weight={"medium"}>
                    {page}
                  </Typography>
                </PageItem>
              );
            } else {
              return (
                <PageItem
                  key={i}
                  isactive={currentPage === page ? "true" : "false"}
                  onClick={() => {
                    setPage(pagesArray[i - 1] + 1);
                    onPageChange(pagesArray[i - 1] + 1);
                  }}
                >
                  {page > 0 ? (
                    <Typography lh="2" weight={"medium"}>
                      {page}
                    </Typography>
                  ) : (
                    <Typography>...</Typography>
                  )}
                </PageItem>
              );
            }
          })}
        </Pages>
        <Button onClick={Next} disabled={currentPage === totalPages}>
          <Typography size={"lg"} weight={"medium"} mr="0.8" m_display="none">
            Next
          </Typography>
          <IconContainer>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="100%"
              height="100%"
              viewBox="0 0 20 20"
              fill="none"
            >
              <path
                d="M7.5 4.16675L12.5 10.0001L7.5 15.8334"
                stroke="currentColor"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </IconContainer>
        </Button>
      </Body>
    </Container>
  );
};

export default Pagination;

const Container = styled.div`
  width: 100%;
  color: white;
`;

const Body = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  @media only screen and (max-width: 769px) {
  }
`;

const Button = styled.div<{ disabled: boolean }>`
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  display: flex;
  align-items: center;
  color: ${(props) => (props.disabled ? Colors.grey600 : Colors.yellow400)};

  @media only screen and (max-width: 769px) {
    border-radius: 0.8rem;
  }
`;

const Pages = styled.div`
  display: flex;
  width: fit-content;
`;
const PageItem = styled.div<{ isactive: string }>`
  cursor: pointer;
  width: 4rem;
  height: 4rem;
  border-radius: 50%;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${(props) =>
    props.isactive === "true" ? Colors.grey700 : "transparent"};
`;

const IconContainer = styled.div`
  width: 2rem;
  height: 2rem;
  @media only screen and (max-width: 769px) {
    width: 3.6rem;
    height: 3.6rem;
  }
`;
